/**
 * Text-only button (parity with PeakApple `PeakTextButton`): no fill or
 * outline, secondary label, the same height as other CTAs so rows align,
 * and a ≥44px hit area. Used for Load more / Load earlier and Cancel actions
 * in the sessions, schedule and log flows.
 */
export const TEXT_BUTTON_CLASS =
  "btn btn-ghost min-h-11 h-11 rounded-xl px-4 border-0 shadow-none bg-transparent text-sm font-medium font-grotesk normal-case text-base-content/60 hover:bg-transparent hover:text-base-content/80 active:bg-transparent focus-visible:ring-2 focus-visible:ring-base-content/30 disabled:bg-transparent disabled:text-base-content/40";
